export default function Input({ label, error, className = '', ...props }) {
  return (
    <div className={className}>
      {label && <label className="block text-[13px] font-medium text-[#94a3b8] mb-1.5">{label}</label>}
      <input
        className={`w-full px-4 py-2.5 bg-[#060a10] border ${error ? 'border-red-500' : 'border-[rgba(148,163,184,0.10)]'} rounded-lg text-[#e2e8f0] text-[13px] placeholder-[#475569] focus:outline-none focus:border-[#06b6d4] transition-colors`}
        {...props}
      />
      {error && <p className="mt-1 text-[12px] text-red-400">{error}</p>}
    </div>
  );
}

export function Select({ label, error, children, className = '', ...props }) {
  return (
    <div className={className}>
      {label && <label className="block text-[13px] font-medium text-[#94a3b8] mb-1.5">{label}</label>}
      <select
        className={`w-full px-4 py-2.5 bg-[#060a10] border ${error ? 'border-red-500' : 'border-[rgba(148,163,184,0.10)]'} rounded-lg text-[#e2e8f0] text-[13px] focus:outline-none focus:border-[#06b6d4] transition-colors`}
        {...props}
      >
        {children}
      </select>
      {error && <p className="mt-1 text-[12px] text-red-400">{error}</p>}
    </div>
  );
}

export function Textarea({ label, error, className = '', ...props }) {
  return (
    <div className={className}>
      {label && <label className="block text-[13px] font-medium text-[#94a3b8] mb-1.5">{label}</label>}
      <textarea
        className={`w-full px-4 py-2.5 bg-[#060a10] border ${error ? 'border-red-500' : 'border-[rgba(148,163,184,0.10)]'} rounded-lg text-[#e2e8f0] text-[13px] placeholder-[#475569] focus:outline-none focus:border-[#06b6d4] transition-colors resize-y`}
        rows={4}
        {...props}
      />
      {error && <p className="mt-1 text-[12px] text-red-400">{error}</p>}
    </div>
  );
}
